"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RetirementIncomePageTwo;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _CollapseInfo = _interopRequireDefault(require("../Wizard/CollapseInfo"));
var _utils = require("../../middleware/utils");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
var _RetirementIncomeRefinementModal = _interopRequireDefault(require("./RetirementIncomeRefinementModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function RetirementIncomePageTwo(_ref) {
  var _apiData$data, _apiData$data2, _apiData$data3, _apiData$data4, _apiData$data5, _apiData$data6, _apiData$data7;
  var {
    apiData,
    disclosureHandleClose,
    showDisclosure,
    refinementHandleClose,
    snapshot,
    fetchDataScienceResults,
    showRefinement
  } = _ref;
  var {
    values: {
      contributionPercent,
      retirementAge,
      lifeExpectancy,
      savings,
      incomeGoalPercent,
      annualPay
    },
    setFieldValue
  } = (0, _formik.useFormikContext)();
  var closeAndResetRefinementModal = snapshot => {
    refinementHandleClose();
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var monthlyIncomeActual = apiData === null || apiData === void 0 || (_apiData$data = apiData.data) === null || _apiData$data === void 0 || (_apiData$data = _apiData$data.monthlyIncomeActual) === null || _apiData$data === void 0 ? void 0 : _apiData$data[0];
  var mothlyIncomeGoal = apiData === null || apiData === void 0 || (_apiData$data2 = apiData.data) === null || _apiData$data2 === void 0 || (_apiData$data2 = _apiData$data2.monthlyIncomeGoal) === null || _apiData$data2 === void 0 ? void 0 : _apiData$data2[0];
  var recommendCont = apiData === null || apiData === void 0 || (_apiData$data3 = apiData.data) === null || _apiData$data3 === void 0 || (_apiData$data3 = _apiData$data3.recommendCont) === null || _apiData$data3 === void 0 ? void 0 : _apiData$data3[0];
  var contributionRate = contributionPercent / 100;
  var annualPayAsNum = (0, _utils.parseCurrencyString)(null, annualPay);
  var additionalMonthlySavingsGoal = annualPayAsNum * (recommendCont - contributionRate) / 12;

  // Set up data for first CollapseInfo
  var label = 'Estimated monthly income in retirement based on current savings';
  var total = (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data4 = apiData.data) === null || _apiData$data4 === void 0 || (_apiData$data4 = _apiData$data4.monthlyIncomeActual) === null || _apiData$data4 === void 0 ? void 0 : _apiData$data4[0]);
  var id = 'estimatedMonthlyIncome';
  var contentArray = [{
    label: "Current monthly savings (".concat(contributionPercent, "%) from now until you retire at ").concat(retirementAge),
    value: (0, _utils.numberToCurrencyString)(calculateMonthlySavings((0, _utils.parseCurrencyString)(null, annualPay), (0, _utils.parseCurrencyString)(null, contributionPercent))),
    id: 'currentMonthlySavings'
  }, {
    label: 'Current retirement savings total',
    value: '$' + savings,
    id: 'currentMonthlySavingsTotal'
  }, {
    label: 'Estimated social security income ',
    value: (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data5 = apiData.data) === null || _apiData$data5 === void 0 || (_apiData$data5 = _apiData$data5.monthlySSBenefit) === null || _apiData$data5 === void 0 ? void 0 : _apiData$data5[0]),
    id: 'estimatedSocialSecurityIncome',
    popoverText: socialSecPopoverText,
    popoverId: 'socialSecurity'
  }, {
    label: 'Total estimated retirement savings ',
    value: (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data6 = apiData.data) === null || _apiData$data6 === void 0 || (_apiData$data6 = _apiData$data6.balanceAtRetirement) === null || _apiData$data6 === void 0 ? void 0 : _apiData$data6[0]),
    id: 'totalEstimatedRetirementSavings'
  }, {
    label: 'Retirement age ',
    value: retirementAge,
    id: 'retirementAge'
  }, {
    label: 'Life expectancy ',
    value: lifeExpectancy,
    id: 'lifeExpectancy',
    popoverText: lifeExpectancyPopoverText,
    popoverId: 'lifeExpectancy'
  }];

  // Set up data for second CollapseInfo
  var label2 = "\n      <div className='archetype-spacing--tiny'>Target monthly income in retirement</div>\n      <p className='copy-sm'>\n        Represents the portion of your current monthly income that you would like to\n        have available in retirement. Click \"Edit your inputs & our assumptions\u201D to\n        update this.\n      </p>\n    ";
  var total2 = (0, _utils.numberToCurrencyString)(apiData === null || apiData === void 0 || (_apiData$data7 = apiData.data) === null || _apiData$data7 === void 0 || (_apiData$data7 = _apiData$data7.monthlyIncomeGoal) === null || _apiData$data7 === void 0 ? void 0 : _apiData$data7[0]);
  var id2 = 'targetMonthlyIncome';
  var contentArray2 = [{
    label: 'Percentage of current monthly income you’d like to receive in retirement',
    value: incomeGoalPercent + '%',
    id: 'percentageOfMonthlyIncome'
  }, {
    label: 'Additional monthly savings needed to meet your monthly income target',
    value: (0, _utils.numberToCurrencyString)(Math.max(additionalMonthlySavingsGoal, 0)),
    id: 'additionalMonthlySavingsNeeded'
  }];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isScenarioWithEnoughSavings(mothlyIncomeGoal, monthlyIncomeActual) && /*#__PURE__*/_react.default.createElement("h4", {
    className: "mb-0"
  }, "Nice Work!", /*#__PURE__*/_react.default.createElement("br", null), "Your current savings are on track to cover your target monthly income in retirement which is ".concat(incomeGoalPercent, "% "), /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    text: incomeGoalPercentText,
    fieldName: "incomeGoalPercent"
  }), " of your current income. "), !isScenarioWithEnoughSavings(mothlyIncomeGoal, monthlyIncomeActual) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, " Consider increasing your monthly retirement savings by "), /*#__PURE__*/_react.default.createElement("div", {
    className: "inline"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "data-lg"
  }, (0, _utils.numberToCurrencyString)(additionalMonthlySavingsGoal)), /*#__PURE__*/_react.default.createElement("h4", null, " per month"))), /*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
    label: label,
    total: total,
    contentArray: contentArray,
    id: id
  }), /*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
    label: label2,
    total: total2,
    id: id2,
    labelPopoverId: "targetRetirmentIncome",
    contentArray: contentArray2
  }), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    textArray: disclosureArray,
    handleClose: disclosureHandleClose,
    show: showDisclosure
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeRefinementModal.default, {
    handleClose: closeAndResetRefinementModal,
    snapshot: snapshot,
    show: showRefinement,
    fetchDataScienceResults: fetchDataScienceResults
  }));
}
var socialSecPopoverText = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "To exclude Social Security, click \"Edit Your Inputs & Our Assumptions\" and enter $0. Click\xA0", /*#__PURE__*/_react.default.createElement("a", {
  href: "https://www.ssa.gov/OACT/quickcalc/index.html",
  target: "_blank",
  rel: "noopener noreferrer"
}, "here"), "\xA0to obtain your own estimate or\xA0", /*#__PURE__*/_react.default.createElement("a", {
  href: "https://secure.ssa.gov/RIL/SiView.do",
  target: "_blank",
  rel: "noopener noreferrer"
}, "here"), "\xA0to register with the SSA.");
var lifeExpectancyPopoverText = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Average life expectancy from\xA0", /*#__PURE__*/_react.default.createElement("a", {
  href: "https://www.cdc.gov/nchs/fastats/life-expectancy.htm",
  target: "_blank",
  rel: "noopener noreferrer"
}, "CDC.gov"), "\xA0is 77.0. MassMutual uses a higher estimate to present a conservative view of how long your savings will last.");
var incomeGoalPercentText = "Represents the percent of your current monthly income that you would like to have available in retirement. Click \"Edit Your Inputs & Our Assumptions\u201D to update this";
function isScenarioWithEnoughSavings(goal, actual) {
  return actual >= goal;
}
var disclosureArray = ["This interactive calculator is a self-help tool and is not intended to provide financial advice or product recommendations. The results and explanations generated by this calculator are based upon, and will vary due to, your input and certain assumptions made by us. All projections are hypothetical in nature, do not reflect actual results, and are not guarantees of future results. This calculator is designed to project hypothetical retirement income values based on numerous assumptions, including that your current age is less than your retirement age. MassMutual will assume no liability for the use of or reliance on this calculator. For a more accurate and detailed analysis specific to your circumstances, we encourage you to contact a qualified financial professional.", 'The information provided is not written or intended as specific tax or legal advice. MassMutual, its employees and representatives are not authorized to give tax or legal advice. Individuals are encouraged to seek advice from their own tax or legal counsel.', "This Social Security estimate is based only on the information you have supplied and the latest Social Security data. Changes in your earnings and/or laws may affect this analysis. This calculation does not take into account any taxes that may be imposed on your Social Security income. Your earnings history is unique and may differ substantially from the above assumptions. We therefore urge you to <a href=\"https://www.ssa.gov/OACT/quickcalc/index.html\" target=\"_blank\">click here</a> to get an estimate of your benefits or <a href=\"https://secure.ssa.gov/RIL/SiView.do\" target=\"_blank\">register here</a> to view your actual projected benefits from the Social Security Administration. This calculator does not distinguish between tax-qualified and non-tax qualified retirement funds. Taxes are not taken into consideration for retirement income calculations.", "Insurance products issued by Massachusetts Mutual Life Insurance Company (MassMutual) and its subsidiaries, C.M. Life Insurance Company (C. M. Life) and MML Bay State Life Insurance Company (MML Bay State), Springfield, MA 01111-0001. C.M. Life and MML Bay State are non-admitted in New York."];
function calculateMonthlySavings(annualPay, contributionPercent) {
  return annualPay * (contributionPercent / 100) / 12;
}